import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AccessTokenModal from "../components/AccessTokenModal";

import "../styles/TeacherDashboard.css";
import TeacherDemographicReport from "../components/TeacherDemographicReport";

// import history from "../images/history.png";
// import tutorials from "../images/tutorials.png";
import TeacherStudentHeader from "../components/TeacherStudentHeader";
import { teacherMenuItems } from "../components/TeacherMenuItems";

const TeacherDemographicReportPage = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  //   const [showUploadForm, setShowUploadForm] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/teacherFeedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/teacher"); // Navigate to home page
    }
    resetSearch(); // Reset search whenever a new section is selected
  };

  // Determine which parts of the header to show based on the active menu item
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <TeacherStudentHeader
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        // onSearch={handleSearch}
        teacherMenuItems={teacherMenuItems}
        setActiveItem={handleActiveItemChange}
      />
      <main className="main-content">
        {/* <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={teacherMenuItems}
          resetSearch={resetSearch}
        /> */}
        <div className="content">
          <TeacherDemographicReport />
        </div>
      </main>
      <AccessTokenModal />
    </div>
  );
};

export default TeacherDemographicReportPage;
